import { render, staticRenderFns } from "./ApplicantStakeholdersDocuments.vue?vue&type=template&id=43e2db8c&scoped=true&"
import script from "./ApplicantStakeholdersDocuments.vue?vue&type=script&lang=js&"
export * from "./ApplicantStakeholdersDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantStakeholdersDocuments.vue?vue&type=style&index=0&id=43e2db8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e2db8c",
  null
  
)

export default component.exports